export const columns = [
  {
    Header: "Nombre",
    accessor: "name",
    filterable: true,
    filterMethod: (filter, row) => row.name?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Cantidad de Rangos",
    accessor: "rangesNum",
    filterable: true,
    filterMethod: (filter, row) => String(row.rangesNum)?.toLowerCase().includes(filter.value.toLowerCase())
  },
];